export const UNIVERSAL_UPLOAD_ANY_LARGE_FILE = "UNIVERSAL_UPLOAD_ANY_LARGE_FILE";
